var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 370,
    viewBox: "0 0 2 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 1C2.00002 0.447723 1.5523 2.41411e-08 1.00002 0C0.447731 -2.41411e-08 1.61099e-05 0.447723 1.60858e-05 1L2.00002 1ZM0 369L-4.37114e-08 370L2 370L2 369L0 369ZM1.60858e-05 1L0 369L2 369L2.00002 1L1.60858e-05 1Z",
    fill: "url(#paint0_linear_39_6336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_6336",
    x1: 1,
    y1: 369,
    x2: 0.999932,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C1C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#D11C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D11C1C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalRed);
export default __webpack_public_path__ + "static/media/verticalRed.44bbd1ba58748141b371e82d93c9a1f2.svg";
export { ForwardRef as ReactComponent };